export default defineNuxtPlugin(() => {
  const route = useRoute()
  // TODO: this doesn't capture all search pages like the category ones
  // should use route.meta
  if (route.name === 'campsites-search' || route.name === 'campsite-detail') {
    requestIdleCallback(() => {
      const gallery = document.getElementById('search-gallery-0')
      requestAnimationFrame(() => {
        gallery?.setAttribute('data-gallery-position', `${gallery?.scrollLeft}`)
      })
    })
  }
})
